module.exports = __webpack_public_path__ + "static/media/9.5a12c4d1.jpg";